import React, { useState, useEffect } from "react";
import { Box, Text, Grid, Paper, Badge, Transition } from "@mantine/core";
import dayjs from "dayjs";

const extract = (user) => {
  if (user) {
    const { nombres, apellidos, code } = user;
    return (
      <>
        {nombres.slice(0, 12)} {apellidos.slice(0, 12)}
        <br />
        <strong>{code}</strong>
      </>
    );
  }
};

const TicketList = ({ tickets, obtenerComida, obtenerUsuario }) => {
  const [displayTickets, setDisplayTickets] = useState([]);
  const [animationKey, setAnimationKey] = useState(0);

  // Sort tickets by creation date, most recent first
  const sortedTickets = [...tickets].sort((a, b) =>
    dayjs(b.create_at).diff(dayjs(a.create_at))
  );

  useEffect(() => {
    setDisplayTickets(sortedTickets);
  }, [tickets]);

  return (
    <Box sx={{ width: "100%", height: "100%", overflow: "hidden" }}>
      {displayTickets.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            color: "#888",
            textAlign: "center",
          }}
        >
          <Text size="xl">No hay tickets generados</Text>
        </Box>
      ) : (
        <Grid key={animationKey} gutter="xs">
          {displayTickets.map((ticket, index) => (
            <Transition
              key={index}
              mounted={true}
              transition="slide-right"
              duration={500}
              timingFunction="ease"
            >
              {(styles) => (
                <Grid.Col
                  span={12}
                  style={{
                    ...styles,
                    animationDelay: `${index * 100}ms`,
                  }}
                >
                  <Paper
                    shadow="xs"
                    p="xs"
                    sx={{
                      background: ticket.sync
                        ? "linear-gradient(45deg, #e0f3fc, #b3e0ff)"
                        : "linear-gradient(45deg, #fff0f0, #ffd1d1)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "scale(1.02)",
                        boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                      },
                    }}
                  >
                    <Grid>
                      <Grid.Col span={2}>
                        <Text size="sm" color="dark.6" fz={18} weight={500}>
                          Ticket: <b>{ticket.pre_ticket_id}</b>
                        </Text>
                      </Grid.Col>
                      <Grid.Col span={3}>
                        <Text size="sm" color="dark.6" fz={18} weight={500}>
                          {extract(obtenerUsuario(ticket.pre_usuario_id))}
                        </Text>
                      </Grid.Col>
                      <Grid.Col span={2}>
                        <Text size="sm" color="dark.6" fz={18} weight={500}>
                          <strong>{obtenerComida(ticket.pre_comida_id)}</strong>
                        </Text>
                      </Grid.Col>
                      <Grid.Col span={3}>
                        <Badge
                          color={ticket.sync ? "green" : "yellow"}
                          variant="filled"
                          size="sm"
                          fz={30}
                        >
                          {ticket.sync ? "Sincronizado" : "Pendiente"}
                        </Badge>
                      </Grid.Col>
                      <Grid.Col span={2}>
                        <Text size="xs" color="dark.4" fz={18}>
                          {dayjs(ticket.create_at)
                            .tz("America/Guayaquil") // zona horaria de Ecuador
                            .format("DD-MM-YYYY HH:mm:ss")}
                        </Text>
                      </Grid.Col>
                    </Grid>
                  </Paper>
                </Grid.Col>
              )}
            </Transition>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default TicketList;
